import React, { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface StatItem {
  label: ReactNode
  value: ReactNode
  hint?: ReactNode
  active?: boolean
  onClick?: () => void
}

/** Vodorovný pruh souhrnů oddělených linkami (Midday/Mercury). */
export const StatStrip = ({ items, className }: { items: StatItem[]; className?: string }) => (
  <div
    className={cn(
      'grid grid-cols-1 overflow-hidden rounded-lg border divide-y sm:grid-cols-[repeat(var(--stat-cols),minmax(0,1fr))] sm:divide-y-0 sm:divide-x',
      className,
    )}
    style={{ '--stat-cols': items.length } as React.CSSProperties}
  >
    {items.map((item, i) => {
      const Comp = item.onClick ? 'button' : 'div'
      return (
        <Comp
          key={i}
          type={item.onClick ? 'button' : undefined}
          onClick={item.onClick}
          className={cn(
            'flex flex-col gap-1.5 px-5 py-4 text-left',
            item.onClick && 'transition-colors hover:bg-muted',
            item.active && 'bg-muted',
          )}
        >
          <span className="text-xs text-muted-foreground">{item.label}</span>
          <span className="text-foreground">{item.value}</span>
          {item.hint && <span className="text-xs text-muted-foreground tabular">{item.hint}</span>}
        </Comp>
      )
    })}
  </div>
)
